module.exports = __webpack_public_path__ + "static/media/memory.857e0b8e.svg";